import bbbbSsctCakeLp from "../abis/development/bbbbSsct/cakeLp";

const host = "https://bscscan.com/address";

export default [
  {
    name: "BBBB-SSCT",
    type: "ssct",
    contractAddress: "0x57ea9f78c18D1A2Ca4b65cbd904C474CC5bA39b9",
    minApr: 159,
    abi: bbbbSsctCakeLp.abi,
    url: `${host}/0x57ea9f78c18D1A2Ca4b65cbd904C474CC5bA39b9`,
    decimals: 18,
  },
];
